import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITAFBookB2 } from './taf-book-b2-list';

import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TAFBookB2Service {

    //need to have this somewhere besides hardcoded in here

    //private _tafBookB2Url = ` http://localhost:55706/api/systemmanagement/TAFBookB2`;
    private _tafBookB2Url = `api/systemmanagement/TAFBookB2`;



    constructor(private httpHelper: HttpHelper) { }

    getTAFBookB2(): Observable<ITAFBookB2> {
         return this.httpHelper.get(`${this._tafBookB2Url}`)
             //.map((response: Response) => <ITAFBookB2> response.json())
             //.do(data => console.log('ITafBookB2: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b2/taf-book-b2.service.ts
 **/